<style>
    .ag-theme-material .ag-cell {
        line-height: 35px !important;
    }
</style>

<template>
    <div>
        <vx-card class="p-4 mb-6">
            <div class="flex flex-wrap items-center justify-between mb-10">
                <div class="flex items-center">
                    <h4 style="margin-left: 10px">Stock Check</h4>
                </div>
                <div class="flex items-center">
                    <vs-button
                        @click="refreshData"
                        class="btn mb-4 md:mb-0 mr-1"
                        icon="refresh"
                    >Refresh</vs-button>
                    <vs-button
                        :to="{name: 'stock-check-add'}"
                        class="btn mb-4 md:mb-0 mr-1"
                        icon="add"
                    >Add</vs-button>
                    <vs-button
                        @click="count.show = true"
                        class="btn mb-4 md:mb-0 mr-1"
                        icon="view_list"
                    >Count</vs-button>
                    <vs-button
                        class="mb-4 md:mb-0 mr-1"
                        icon="filter_list"
                        @click="filterInit"
                    >Filter</vs-button>
                    <vs-button
                        @click="exportExcel({ endpoint: 'inventories/stockcheck/export', filter: filter, name: 'stock_check' })"
                        class="btn mb-4 md:mb-0 mr-1"
                        icon="import_export"
                    >Export</vs-button>
                </div>
            </div>
            <ag-grid-vue
                :gridOptions="gridOptions"
                class="ag-theme-material w-100 my-4 ag-grid-table"
                :columnDefs="columnDefs"
                :defaultColDef="defaultColDef"
                :rowData="data"
                colResizeDefault="shift"
                :animateRows="false"
                rowSelection="single"
                :floatingFilter="false"
                @selection-changed="onSelectionChanged"
                @rowDoubleClicked="viewData"
            ></ag-grid-vue>
            <p class="text-right">
                <b>Showing {{ dataFrom }} to {{ dataTo }} of {{ dataTotal }} total entries</b>
            </p>
            <vs-pagination :total="totalPage" v-model="currentPage"></vs-pagination>
        </vx-card>
        <vs-prompt
            @accept="searchCount"
            :active.sync="count.show"
            title="Count"
            >
            <div class="con-exemple-prompt">
                <div class="vx-col w-full">
                    <div class="vx-row mb-3">
                        <div class="vx-col w-1/3">
                            Stock Check ID*
                        </div>
                        <div class="vx-col w-2/3">
                            <vs-input class="w-full" v-model="count.id" @keyup.enter="searchCount"/>
                        </div>
                    </div>
                </div>
                <vs-alert v-if="count.error" color="danger" vs-icon="new_releases" class="mt-5">
                    {{ count.error }}
                </vs-alert>
            </div>
        </vs-prompt>
        <vs-prompt @accept="fetchData" title="Filter" :active.sync="showFilter">
            <div class="con-exemple-prompt">
                <vs-input v-model="filter.reference" class="mb-2 w-full" label="Reference" />
                <label class="vs-input--label">Warehouse</label>
                <vs-select
                    class="selectExample mb-2"
                    v-model="filter.warehouse_id"
                    width="100%"
                    autocomplete
                    @input-change="searchDropdown($event, filter.warehouses)"
                >
                    <vs-select-item v-for="(item, index) in filter.warehouses.data" :key="index" :value="item.id" :text="item.warehouses_code"/>
                </vs-select>
                <label class="vs-input--label">Client</label>
                <vs-select
                    class="selectExample mb-2"
                    v-model="filter.client_id"
                    width="100%"
                    autocomplete
                    @input-change="searchDropdown($event, filter.clients)"
                >
                    <vs-select-item v-for="(item, index) in filter.clients.data" :key="index" :value="item.id" :text="item.client_code"/>
                </vs-select>
                <label class="vs-input--label">Check Date</label>
                <vs-row vs-w="12" vs-justify="space-between" class="mb-2">
                    <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="5" style="padding-left: 0">
                        <flat-pickr class="vx-col w-full p-2" v-model="filter.check_date_from" />
                    </vs-col>
                    <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="2">To</vs-col>
                    <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-w="5" style="padding-right: 0">
                        <flat-pickr class="vx-col w-full p-2" v-model="filter.check_date_to" />
                    </vs-col>
                </vs-row>
                <label class="vs-input--label">Status</label>
                <vs-select
                    class="selectExample mb-2"
                    v-model="filter.status"
                    width="100%"
                    autocomplete
                >
                    <vs-select-item value="" text="Any"/>
                    <vs-select-item value="Open" text="Open"/>
                    <vs-select-item value="Closed" text="Closed"/>
                </vs-select>
            </div>
        </vs-prompt>
    </div>
</template>

<script>
import vSelect from "vue-select";
import FileSaver from "file-saver";
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

export default {
    components: {
        vSelect,
        AgGridVue,
        flatPickr
    },
    data() {
        return {
            searchQuery: "",
            gridOptions: {},
            data: [],
            maxPageNumbers: 7,
            gridApi: null,
            isLoading: false,
            columnApi: null,
            showFilter: false,
            columnDefs: null,
            defaultColDef: {
                sortable: true,
                editable: false,
                resizable: true,
                suppressMenu: true
            },
            filter: {
                reference: '',
                clients: {
                    data: [],
                    loading: false,
                    endpoint: 'master/clients',
                    objectKey: 'client_code'
                },
                warehouses: {
                    data: [],
                    loading: false,
                    endpoint: 'master/warehouses',
                    objectKey: 'warehouses_code'
                },
                client_id: null,
                warehouse_id: null,
                status: '',
                check_date_from: null,
                check_date_to: null
            },
            count: {
                show: false,
                id: '',
                error: ''
            },
            totalPage: 0,
            currentPage: 1,
            dataFrom: 0,
            dataTo: 0,
            dataTotal: 0,
            selectedId: null
        };
    },
    watch: {
        isLoading: function() {
            if (this.isLoading) {
                this.$vs.loading();
            } else {
                this.$vs.loading.close();
            }
        },
        currentPage: function() {
            this.fetchData();
        }
    },
    methods: {
        onSelectionChanged() {
            var selectedRows = this.gridApi.getSelectedRows()
            var selectedRowsString = ''
            selectedRows.forEach(function(selectedRow, index) {
                if (index !== 0) {
                selectedRowsString += ', '
                }
                selectedRowsString += selectedRow.id
            })
            this.selectedId = selectedRowsString
        },
        refreshData() {
            this.fetchData();
        },
        fetchData() {
            this.isLoading = true;
            this.$http.post('inventories/stockcheck?page=' + this.currentPage, this.filter)
            .then(res => {
                this.isLoading = false;
                this.totalPage = res.data.last_page;
                this.dataTotal = res.data.total;
                this.dataFrom = res.data.from;
                this.dataTo = res.data.to;
                this.data = res.data.data
            })
            .catch(error => {
                this.isLoading = false;
                this.$vs.dialog({
                    type: "confirm",
                    color: "danger",
                    title: "Server Error",
                    text: "Try again?",
                    accept: () => {
                        this.fetchData();
                    },
                    acceptText: "Yes",
                    cancelText: "No"
                });
                return;
            })
        },
        filterInit() {
            this.isLoading = true;
            Promise.all([
                this.$http.post("/master/clients"),
                this.$http.post("/master/warehouses")
            ])
                .then(
                    this.$http.spread(
                        (
                            clients,
                            warehouses
                        ) => {
                            this.filter.clients.data = clients.data.data;
                            this.filter.warehouses.data = warehouses.data.data;

                            this.filter.warehouses.data.unshift({id: null, warehouses_code: 'Any'})
                            this.filter.clients.data.unshift({id: null, client_code: 'Any'})

                            this.showFilter = true;
                            this.isLoading = false;
                        }
                    )
                )
                .catch(() => {
                    this.isLoading = false;
                    this.$vs.dialog({
                        type: "confirm",
                        color: "danger",
                        title: "Server Error",
                        text: "Try again?",
                        accept: () => {
                            this.filterInit();
                        },
                        acceptText: "Yes",
                        cancelText: "No"
                    });
                });
        },
        filterData() {
            this.fetchData();
        },
        viewData() {
            this.$router.push({
                name: 'stock-check-view',
                params: {
                    id: this.selectedId
                }
            })
        },
        searchCount() {
            this.count.error = ''
            this.count.show = false
            if(!this.count.id) {
                this.count.error = 'Please fill stock check ID'
                this.count.show = true
                return false
            }
            else {
                this.isLoading = true
                this.$http.post('inventories/stockcheck/search', {id: this.count.id})
                .then(res => {
                    this.isLoading = false
                    this.$router.push({
                        name: 'stock-check-count',
                        params: {
                            id: res.data.id,
                        }
                    })
                })
                .catch(error => {
                    this.isLoading = false
                    const message = error.response.data.message ? error.response.data.message : 'Something went wrong.'
                    this.count.error = message
                    this.count.show = true
                })
            }
        }
    },
    mounted() {
        this.fetchData();
        this.gridApi = this.gridOptions.api;
        this.gridColumnApi = this.gridOptions.columnApi;
    },
    beforeMount() {
        this.columnDefs = [
            {
                headerName: "ID",
                field: "id",
                width: 120
            },
            {
                headerName: "Reference",
                field: "reference",
                width: 120
            },
            {
                headerName: "Date",
                field: "check_date",
                width: 120
            },
            {
                headerName: "Warehouse ID",
                field: "warehouses_code",
                width: 120
            },
            {
                headerName: "Client ID",
                field: "client_code",
                width: 120
            },
            {
                headerName: "Count ID",
                field: "count_status",
                width: 120
            },
            {
                headerName: "Status",
                field: "status",
                width: 120
            },
        ];

        this.gridOptions.getRowHeight = function(params) {
            return 35;
        }
    }
};
</script>